<div class="page-content">
  <h1>Cannot access DeliveryPortal</h1>

  <h2>Need access?</h2>

  <gc-text>
    Conctact us and <b>state which part of DeliveryPortal</b> you wish to
    access.
  </gc-text>

  <hr />

  <div class="actions-container">
    <div class="copy-container">
      <gc-text [variant]="'informationBold'">Contact</gc-text>

      <app-copy-string
        [value]="'cr-rollout@globalconnect.se'"
        [successMessage]="'Copied'"
      />
    </div>

    <gc-button (clicked)="logout()">Try again</gc-button>
  </div>
</div>

<app-feedback-alert />
